import { Injectable } from '@nestjs/common';
import { InjectRepository } from '@nestjs/typeorm';
import { Repository } from 'typeorm';
import { RmPriceList } from './rm-price-list.entity';
import {RmPriceListAdapter} from './dto/rm-price-list.adapter';
import { ErrorResponse } from '@gtpl/shared-models/common-models';
import { RmPriceListDTO } from './dto/rm-price-list.dto';
import { AllRmPriceListResponse, RmPriceListResponse } from '@gtpl/shared-models/masters';
import { RmPriceListRequest } from './dto/rm-price-list.request';
let moment = require('moment');
moment().format();
import { Cron } from '@nestjs/schedule';



@Injectable()
export class RmPriceListService {
    constructor(
        @InjectRepository(RmPriceList) private rmPriceListRepository: Repository<RmPriceList>,
        private RmPriceListAdapter: RmPriceListAdapter,
      ) { }

      async createRmPriceList(rmPriceListDTO:RmPriceListDTO, isUpdate: boolean,request:Request): Promise<RmPriceListResponse> {
        try {
        
        if (!isUpdate) {
            const rmPriceListEntity = await this.getRmPriceList(rmPriceListDTO.date);
          if (rmPriceListEntity) {
            throw new ErrorResponse(11104, 'Rm PriceList already exists');
          }
        }
        else{
            const rmPriceListEntity = await this.getRmPriceList(rmPriceListDTO.date);
            if (rmPriceListEntity) {
                if(rmPriceListEntity.rmPriceListId!=rmPriceListDTO.rmPriceListId){
                    throw new ErrorResponse(11104, 'Rm Price List  already exists');
                }
            }
        }
        const convertedrmPriceListEntity:RmPriceList = this.RmPriceListAdapter.convertDtoToEntity(rmPriceListDTO,isUpdate);
        const savedrmPriceListEntity: RmPriceList = await this.rmPriceListRepository.save(convertedrmPriceListEntity);
        const savedrmPriceListDTO: RmPriceListDTO = this.RmPriceListAdapter.convertEntityToDto(savedrmPriceListEntity);
       
         if (savedrmPriceListDTO) {
          const response = new RmPriceListResponse(true,isUpdate ? 11100 : 11101,isUpdate? 'Rm PriceList date Updated Successfully':'Rm PriceList Created Successfully',savedrmPriceListDTO);
          return response;
        } else {
          throw new ErrorResponse(11106,'Rm PriceList saved but issue while transforming into DTO');
        }
      }
      catch (error) {
        return error;
      }
    }
     /**
     * gets all Rm price list details  
     * @returns all the Rm price list details .
     */
      async getAllRmPriceList(): Promise<AllRmPriceListResponse> {  
        try {
            const rmPriceListDTO: RmPriceListDTO[] = [];
           
            const rmPriceListEntities: RmPriceList[] = await this.rmPriceListRepository.find({
                order: { date: "ASC" },
            });
            
            if (rmPriceListEntities.length>0) {
                rmPriceListEntities.forEach(RmPriceListEntity => {
                const convertedrmPriceListDTO:RmPriceListDTO = this.RmPriceListAdapter.convertEntityToDto(RmPriceListEntity);
                rmPriceListDTO.push(convertedrmPriceListDTO);
                });
                const response = new AllRmPriceListResponse(true, 11208, "Rm PriceList retrieved successfully", rmPriceListDTO);
                return response;
            } else {
                //   console.log('yest')
                throw new ErrorResponse(99998, 'No Records Found');
            }
        } catch (err) {
            return err;
        }
    }

    async getRmPriceList(date: Date): Promise<RmPriceList> {
        
            const response = await this.rmPriceListRepository.findOne({
            where: {date: date},
            });
            // console.log(response);
            if (response) {
            return response;
            } else {
            return null;
            }
        }

         /**
     * It deactivates value    Rm price list   
     * @param itemReq      Rm price list as string
     * @returns true or false
     */
          async activateOrDeactivateRmPriceList(rmPriceListReq: RmPriceListRequest): Promise<RmPriceListResponse> {
            try {
                const rmPriceListExists = await this.getRmPriceListById(rmPriceListReq.rmPriceListId);
                if (rmPriceListExists) {
                    if (rmPriceListReq.versionFlag !== rmPriceListExists.versionFlag) {
                        throw new ErrorResponse(10113, 'Someone updated the current RmPriceList information.Refresh and try again');
                    } else {
                        
                            const rmPriceListStatus =  await this.rmPriceListRepository.update(
                                { rmPriceListId: rmPriceListReq.rmPriceListId },
                                { isActive: rmPriceListReq.isActive,updatedUser: rmPriceListReq.updatedUser });
                           
                            if (rmPriceListExists.isActive) {
                                if (rmPriceListStatus.affected) {
                                    const rmPriceListResponse: RmPriceListResponse = new RmPriceListResponse(true, 10115, 'Rm PriceList is de-activated successfully');
                                    return rmPriceListResponse;
                                } else {
                                    throw new ErrorResponse(10111, 'Rm PriceList is already deactivated');
                                }
                            } else {
                                if (rmPriceListStatus.affected) {
                                    const rmPriceListResponse: RmPriceListResponse = new RmPriceListResponse(true, 10114, 'Rm PriceList is activated successfully');
                                    return rmPriceListResponse;
                                } else {
                                    throw new ErrorResponse(10112, 'Rm PriceList is already  activated');
                                }
                            }
                        // }
                    }
                } else {
                    throw new ErrorResponse(99998, 'No Records Found');
                }
            } catch (err) {
                return err;
            }
        }
    
        async getRmPriceListById(rmPriceListId: number): Promise<RmPriceList> {
        //  console.log(employeeId);
            const response = await this.rmPriceListRepository.findOne({
            where: {rmPriceListId: rmPriceListId},
            });
            
            if (response) {
            return response;
            } else {
            return null;
            }
        }

       
        @Cron('41 11 * * *')
        async insertData() {
            try {
                let currentDate = moment().format('YYYY-MM-DD')
                let tommorowDate = moment(currentDate).add(1,'days')
                const todaysData: RmPriceList[]= await this.rmPriceListRepository.find({ order: { rmPriceListId: 'ASC' },where:{date:currentDate}}); 
        let result
        for(const iterator of todaysData){
            const rmPriceListEntity = new RmPriceList()
            rmPriceListEntity.date =tommorowDate.format('YYYY-MM-DD')
            rmPriceListEntity.rmPriceListId = iterator.rmPriceListId;
            rmPriceListEntity.date = iterator.date;
            rmPriceListEntity.minCount = iterator.minCount;
            rmPriceListEntity.maxCount = iterator.maxCount;
            rmPriceListEntity.price = iterator.price;
         
            rmPriceListEntity.createdUser = iterator.createdUser;
            rmPriceListEntity.createdAt = iterator.createdAt;
           
            result = await this.rmPriceListRepository.save(rmPriceListEntity);
         }
         if(result){
            return 'data inserted'
                
            }else{
                return 'data not inserted'
            }
            }
            catch(err ){
                return err
            }
        }
        

}
